// extracted by mini-css-extract-plugin
export default {"mealsBox":"MealBox_mealsBox__qPgjR"};